module.exports = __webpack_public_path__ + "static/assets/9d725f897f2e20e0799bf3aeadb3c88a.svg";